<app-default-card
  [formGroup]="formGroup"
  [title]="'Zählerstände'"
  [error]="hasErrors"
  [errorMessage]="'Zählernummern und -stände müssen angegeben werden'">
  <app-hint-card *ngIf="'gridRegistration.service-request-meter-formpart' | uiAdaptionValue as value">
    {{ value }}
  </app-hint-card>
  <form-row *ngIf="maybeHasNoMeter">
    <mat-checkbox
      [checked]="noMeterPresent"
      (change)="onNoMeterPresentChange($event.checked)"
      [disabled]="disable">
      Es ist noch kein Zähler vorhanden
    </mat-checkbox>
  </form-row>

  <form-row>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Zählernummer</mat-label>
      <input [disabled]="disable" matInput type="text" id="meterNumber" formControlName="meterNumber" />
    </mat-form-field>
  </form-row>

  <form-row>
    <mat-form-field>
      <mat-label>Zählerart</mat-label>
      <mat-select formControlName="deviceType" [disabled]="disable">
        <mat-option *ngFor="let deviceType of deviceTypeNameOptions" [value]="deviceType">
          {{ deviceType }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form-row>

  <!-- Unterformular für Meter One -->
  <h4>Zählerwerk 1 - {{ meterOneObisControl.value }}</h4>
  <form-row>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Zählerstand</mat-label>
      <input
        matInput
        type="text"
        id="meterOneValue"
        [disabled]="disable"
        [formControl]="meterOneValueControl" />
    </mat-form-field>
  </form-row>

  <ng-container *ngIf="hasMeterTwo">
    <!-- Unterformular für Meter Two -->
    <h4>Zählerwerk 2 - {{ meterTwoObisControl.value }}</h4>
    <form-row>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Zählerstand</mat-label>
        <input
          matInput
          type="text"
          id="meterTwoValue"
          [disabled]="disable"
          [formControl]="meterTwoValueControl" />
      </mat-form-field>
    </form-row>
  </ng-container>

  <ng-container *ngIf="hasMeterThree">
    <!-- Unterformular für Meter Three -->
    <h4>Zählerwerk 3 - {{ meterThreeObisControl.value }}</h4>
    <form-row>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Zählerstand</mat-label>
        <input matInput type="text" id="meterThreeValue" [formControl]="meterThreeValueControl" />
      </mat-form-field>
    </form-row>
  </ng-container>
</app-default-card>
